const appointmentFlow = [
    "branch",
    "date",
    "time"
];

export const reset = (stepName) => {
    const currentStep = appointmentFlow.indexOf(stepName);
    const resettable = {};
    appointmentFlow.slice(currentStep + 1)
        .forEach(step => {
            resettable[step] = null;
        });
    return resettable;
};
